import { css, Global, useTheme } from "@emotion/react";
import React from "react";

const GlobalStyles = () => {
    const theme = useTheme();

    return (
        <Global
            styles={css`
                body {
                    margin: 0;
                    padding: 0;

                    &.flyout-garage-enable {
                        bottom: 0;
                        left: 0;
                        overflow: hidden;
                        position: fixed;
                        right: 0;
                        top: 0;
                    }
                }

                html,
                body,
                h1,
                h2,
                h3,
                h4,
                h5,
                h6,
                select,
                textarea,
                input,
                label,
                button {
                    box-sizing: border-box;
                    color: ${theme.palette.common.black};
                    font-family: ${theme.typography.fontFamily};
                    font-size: 16px;
                    font-weight: normal;
                    text-transform: none;
                }

                a {
                    text-decoration: none;
                }

                ul {
                    appearance: none;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                }
            `}
        />
    );
};

export default GlobalStyles;
